// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* IconActionButton.css */

:root {
  --scl--cms-components-iconActionButton-color:            #8A8B8F;
  --scl--cms-components-iconActionButton-hover-background: #EDEEF080;
  --scl--cms-components-iconActionButton-hover-color:      #000000;
}

.scl--cms-components-iconActionButton {
  position:         relative;
  width:            25px;
  height:           25px;
  display:          flex;
  align-items:      center;
  justify-content:  center;
  background:       transparent;
  border:           none;
  border-radius:    4px;
  cursor:           pointer;
  transition:       background-color 0.2s ease, transform 0.1s ease;
  padding:          0;
  margin:           0;
  outline:          none;
  box-sizing:       border-box;
}

.scl--cms-components-iconActionButton:hover,
.scl--cms-components-iconActionButton:not(:disabled):hover {
  background: var(--scl--cms-components-iconActionButton-hover-background);
  color:      var(--scl--cms-components-iconActionButton-hover-color);
}

/* Icon container */
.scl--cms-components-iconActionButton__icon {
  display:        flex;
  align-items:    center;
  justify-content:center;
  width:          100%;
  height:         100%;
  position:       relative;
  pointer-events: none;
}

.scl--cms-components-iconActionButton__icon svg {
  width:          13px;
  height:         13px;
  color:          var(--scl--cms-components-iconActionButton-color);
  transition:     color 0.2s ease;
  pointer-events: none;
}

.scl--cms-components-iconActionButton:hover .scl--cms-components-iconActionButton__icon svg circle,
.scl--cms-components-iconActionButton:hover .scl--cms-components-iconActionButton__icon svg path {
  stroke: var(--scl--cms-components-iconActionButton-hover-color);
}

/* ── Disabled state ──────────────────────────────────────── */

.scl--cms-components-iconActionButton:disabled,
.scl--cms-components-iconActionButton--disabled {
  cursor:     not-allowed;
  opacity:    0.4;
  background: transparent !important;
}

.scl--cms-components-iconActionButton:disabled .scl--cms-components-iconActionButton__icon svg,
.scl--cms-components-iconActionButton--disabled .scl--cms-components-iconActionButton__icon svg {
  color: var(--scl--cms-components-iconActionButton-color);
}

/* ── Size variants ───────────────────────────────────────── */

.scl--cms-components-iconActionButton--edit .scl--cms-components-iconActionButton__icon svg {
  width:  14px;
  height: 14px;
}

.scl--cms-components-iconActionButton--more .scl--cms-components-iconActionButton__icon svg {
  width:  16px;
  height: 16px;
}

.scl--cms-components-iconActionButton--view .scl--cms-components-iconActionButton__icon svg {
  width:  13px;
  height: 13px;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/button-fs-cp/icon-button-op/css/iconActionButton.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,gEAAgE;EAChE,kEAAkE;EAClE,gEAAgE;AAClE;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,iEAAiE;EACjE,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;;EAEE,wEAAwE;EACxE,mEAAmE;AACrE;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,iEAAiE;EACjE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;;EAEE,+DAA+D;AACjE;;AAEA,+DAA+D;;AAE/D;;EAEE,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,wDAAwD;AAC1D;;AAEA,+DAA+D;;AAE/D;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd","sourcesContent":["/* IconActionButton.css */\n\n:root {\n  --scl--cms-components-iconActionButton-color:            #8A8B8F;\n  --scl--cms-components-iconActionButton-hover-background: #EDEEF080;\n  --scl--cms-components-iconActionButton-hover-color:      #000000;\n}\n\n.scl--cms-components-iconActionButton {\n  position:         relative;\n  width:            25px;\n  height:           25px;\n  display:          flex;\n  align-items:      center;\n  justify-content:  center;\n  background:       transparent;\n  border:           none;\n  border-radius:    4px;\n  cursor:           pointer;\n  transition:       background-color 0.2s ease, transform 0.1s ease;\n  padding:          0;\n  margin:           0;\n  outline:          none;\n  box-sizing:       border-box;\n}\n\n.scl--cms-components-iconActionButton:hover,\n.scl--cms-components-iconActionButton:not(:disabled):hover {\n  background: var(--scl--cms-components-iconActionButton-hover-background);\n  color:      var(--scl--cms-components-iconActionButton-hover-color);\n}\n\n/* Icon container */\n.scl--cms-components-iconActionButton__icon {\n  display:        flex;\n  align-items:    center;\n  justify-content:center;\n  width:          100%;\n  height:         100%;\n  position:       relative;\n  pointer-events: none;\n}\n\n.scl--cms-components-iconActionButton__icon svg {\n  width:          13px;\n  height:         13px;\n  color:          var(--scl--cms-components-iconActionButton-color);\n  transition:     color 0.2s ease;\n  pointer-events: none;\n}\n\n.scl--cms-components-iconActionButton:hover .scl--cms-components-iconActionButton__icon svg circle,\n.scl--cms-components-iconActionButton:hover .scl--cms-components-iconActionButton__icon svg path {\n  stroke: var(--scl--cms-components-iconActionButton-hover-color);\n}\n\n/* ── Disabled state ──────────────────────────────────────── */\n\n.scl--cms-components-iconActionButton:disabled,\n.scl--cms-components-iconActionButton--disabled {\n  cursor:     not-allowed;\n  opacity:    0.4;\n  background: transparent !important;\n}\n\n.scl--cms-components-iconActionButton:disabled .scl--cms-components-iconActionButton__icon svg,\n.scl--cms-components-iconActionButton--disabled .scl--cms-components-iconActionButton__icon svg {\n  color: var(--scl--cms-components-iconActionButton-color);\n}\n\n/* ── Size variants ───────────────────────────────────────── */\n\n.scl--cms-components-iconActionButton--edit .scl--cms-components-iconActionButton__icon svg {\n  width:  14px;\n  height: 14px;\n}\n\n.scl--cms-components-iconActionButton--more .scl--cms-components-iconActionButton__icon svg {\n  width:  16px;\n  height: 16px;\n}\n\n.scl--cms-components-iconActionButton--view .scl--cms-components-iconActionButton__icon svg {\n  width:  13px;\n  height: 13px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
